import inm13s1 from './inm13-s1'
import inm14 from './inm14'

export const insProducts = {
  'inm13-s1': inm13s1,
  inm14
}
